export default {
  title: 'Tipos de Página',
  description: 'Gerencie os tipos de página web.',
  labels: {
    new: 'Novo Tipo',
  },
  fields: {
    text: 'Tipo de Página',
    is_active: 'Ativo',
  }
};
